// extracted by mini-css-extract-plugin
export default {"spinner":"NewMarkdownViewer-module__spinner--2QW6e","safe-html-box":"NewMarkdownViewer-module__safe-html-box--cRsz0"};